// src/Components/DynamicTitle.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DynamicTitle = ({ customTitle }) => {
    const location = useLocation();

    useEffect(() => {
        let title;

        if (customTitle) {
            title = `FD | Services / ${customTitle}`;
        } else {
            let pathTitle = location.pathname;
            pathTitle = pathTitle.startsWith('/') ? pathTitle.substring(1) : pathTitle;
            const formatted = pathTitle.replace(/-/g, ' ');
            const capitalized = formatted.replace(/\b\w/g, (match) => match.toUpperCase());
            title = pathTitle ? `FD | ${capitalized}` : 'FD | Home';
        }

        document.title = title;
    }, [location.pathname, customTitle]);

    return null;
};

export default DynamicTitle;
